
import {
	Button,
	Chip,
	Tooltip,
} from "@mui/material"

import {
	GridCellParams,
	GridColDef,
} from "@mui/x-data-grid"

import { Trans } from "@lingui/macro"

export interface TableInterface {
	onRowSelected: (id: string) => void,
}

const defaultColumnDefinition: GridColDef = {
	headerName: "",
	editable: false,
	sortable: false,
	flex: 1,
	headerAlign: "left",
	align: "left",
} as GridColDef
const getTableColumns = (component: TableInterface): GridColDef[] => {
	return [
		{
			...defaultColumnDefinition,
			field: "name",
			headerName: "Affiliato",
			flex: 2,
		},
		{
			...defaultColumnDefinition,
			field: "category",
			headerName: "Categoria",
			flex: 1.5,
			valueGetter: (params) => {
				const products: any[] = params.row.products
				return products.map(it => it.name).join(", ")
			},
			renderCell: (params: GridCellParams): JSX.Element => {
				const products: any[] = params.row.products
				return (
					<>
						<Chip label={products[0].name} size="small" variant="outlined" />
						{products.length > 1 &&
							<Tooltip title={products.filter((_, index) => index != 0).map(it => it.name).join(" - ")}>
								<Chip label={`+${products.length - 1}`} size="small" variant="outlined" />
							</Tooltip>
						}
					</>
				)
			}
		},
		{
			...defaultColumnDefinition,
			field: "city",
			headerName: "Città",
		},
		{
			...defaultColumnDefinition,
			field: "assetCount",
			headerName: "Numero immobili per questo affiliato",
		},
		{
			...defaultColumnDefinition,
			field: "button",
			headerName: "",
			renderCell: (params: { row: any }) => {
				return (
					<Button
						variant="contained"
						size="small"
						disableElevation
						color="secondary"
						sx={{ ml: 2, }}
						onClick={() => component.onRowSelected(params.row.id)}
					>
						<Trans id="affiliates-table.view-assets">
							Vedi immobili
						</Trans>
					</Button>
				)
			},
		},
	]
}

export default getTableColumns
